import Tooltip from "@mui/material/Tooltip";
import InfoIcon from '@mui/icons-material/Info';
import { Filters as TransactionFilters } from "consts/transactions";
import { compareIds } from "util/support";
import type { AbstractFilterProps, Filter } from "ui/widgets/Filters";

export const useFilterPropsOverride = (_: Filter<AbstractFilterProps>[]) => {
    const isDirectionFilter = (filter: Filter<AbstractFilterProps>) =>
        compareIds(filter.props.id, TransactionFilters.direction);

    return (filter: Filter<AbstractFilterProps>) => {
        let propsOverrides = {};

        if (isDirectionFilter(filter)) {
            propsOverrides = {
                InputProps: {
                    startAdornment: (
                        <Tooltip
                            title='Direction indicates the transaction type: ‘C’ stands for Credit (funds received) and ‘D’ stands for Debit (funds withdrawn).'
                            arrow
                        >
                            <InfoIcon
                                color='info'
                            />
                        </Tooltip>
                    )
                }
            };
        }

        return propsOverrides as Filter<AbstractFilterProps>;
    };
};
